import React, { useState, useEffect } from 'react'
import { ProgressByUser } from '../../controllers/ProgressByUser';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../actions/auth';
import { NavBarHome } from '../../components/ui/NavBarHome';
import { GetUserData } from "../../controllers/GetUserData";
import { CertificatesScreenC } from './CertificatesScreenC';
import { ConfigApp } from "../../controllers/ConfigApp";
import  { GetCourses }  from '../../controllers/GetCourses';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';

export default function CertificatesScreen() {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const [list, setList] = useState([]);
    const [name, setName] = useState("");
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [imgSpO, setImgSpO] = useState('');
    const [imgSpT, setImgSpT] = useState('');
    const [imgSpTh, setImgSpTh] = useState('');
    const [imgSpF, setImgSpF] = useState('');
    const [imgIco, setImgIco] = useState('');
    const [courses, setCourses] = useState([]);

    let ran = false;
    useEffect(() => {
        if (ran) return;
            GetCourses(token, user.languaje)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourses(e);
            })
            .catch((e)=>{
                console.error(e);
            });
            ConfigApp("/appConfig").then((e)=>{
                e.forEach(a => {
                    // eslint-disable-next-line default-case
                    switch (a.name_key) {
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_logo" :
                            setImgIco(`data:image/png+xml;base64+xml;base64,${btoa(a.image_value)}`)
                        break;
                       
                        case "edufami_sponsor1" :
                            setImgSpO(`data:image/png+xml;base64+xml;base64,${btoa(a.image_value)}`)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor2" :
                            setImgSpT(`data:image/png+xml;base64+xml;base64,${btoa(a.image_value)}`)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor3" :
                            setImgSpTh(`data:image/png+xml;base64+xml;base64,${btoa(a.image_value)}`)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor4" :
                            setImgSpF(`data:image/png+xml;base64+xml;base64,${btoa(a.image_value)}`)
                        break;
                        
                    }
                })
            })
            .catch((e)=>{
                console.warn(e);
                document.getElementById('invalidMessage').classList.remove('hide');
                
            });
        

        ProgressByUser(token, user.id)
        .then((e)=>{
            setList(e)
            }
        ).catch((e)=>{
            console.error(e);
        });

        GetUserData(token)
        .then((e)=>{
            setName(e.name)
        })
        .catch((e)=>{
            console.error(e);
        });
        return () => (ran = true);
    }, [])

    const disCourse = ()=>{
        if(list.status === "Token is Expired" ){
            dispatch(logout(token));
            history( '/auth/login', {
                replace: true
                });  
        }
        if(list && courses.length>0){
            const entries = Object.values(list);
            let enCourses = Object.values(courses);
            return entries.map((course) => (
                <CertificatesScreenC
                    key={course.course_id}
                    id={course.course_id}
                    name={name}
                    display = {(course.total_contents === course.user_contents)?1:0}
                    imgSpO = {imgSpO}
                    imgSpT = {imgSpT}
                    imgSpTh = {imgSpTh}
                    imgSpF = {imgSpF}
                    imgIco = {imgIco}
                    transTxt = {transTxt}
                    coursesL = {enCourses.find(courseN => courseN.id === course.course_id)}
                />       
            ));

        }
        
        
    }
    return (
        <div className="content">
            <NavBarHome />
            <div className="text-title">{transTxt.menu.certificados}</div>

            <div className="fund-main-question">
                
                <div className="content-questions" >
                    { list && disCourse() }
                </div>
                
            </div>
                
        </div>
    )
}

